import { memo } from "react";

const QuotedMessage = memo(({ contact, quote, isSent }) => {
  if (!quote) return null;

  const borderColor = isSent ? "border-green-300" : "border-gray-400";
  const bgColor = isSent ? "bg-green-600/20" : "bg-gray-300/60";

  const renderPreview = () => {
    switch (quote.messageType) {
      case "image":
        return "📷 Foto";
      case "video":
        return "🎥 Vídeo";
      case "audio":
        return "🎧 Áudio";
      case "document":
        return "📄 Documento";
      default:
        return quote.messageBody;
    }
  };

  return (
    <div
      className={`mb-2 rounded-md border-l-4 px-2 py-1 text-xs ${borderColor} ${bgColor}`}
    >
      <p className="font-semibold">
        {quote.direction === "OUTGOING" ? "Você" : contact.name}
      </p>
      <p className="truncate">{renderPreview()}</p>
    </div>
  );
});

export default QuotedMessage;
